"use strict";
exports.__esModule = true;
exports.contentContextStorage = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports["default"] = React.createContext({});
exports.contentContextStorage = {};
